// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1LO8-","text":"SelectPayment_text__K2yGt","title":"SelectPayment_title__1I49h","btn":"SelectPayment_btn__2I0O9"};